/**
 * Client-side promotion handover that migrates the short‑lived active‑promotion cookie
 * to a route‑keyed record in localStorage.
 * This avoids passing URLs between components by using the current route as the lookup key.
 * Runs once on hydration and on each SPA navigation to ensure correct promotion attribution
 * and prevent double counting.
 */
import useActivePromotion from '../composables/tracking/useActivePromotion'
import usePromotionTrackingLocalStorage from '~/composables/tracking/usePromotionTrackingLocalStorage'

export default defineNuxtPlugin(() => {
  const router = useRouter()
  const route = useRoute()
  const { getActivePromotion, clearActivePromotion } = useActivePromotion()
  const { setRoutePromotion } = usePromotionTrackingLocalStorage()

  // One-time check on initial hydration
  onNuxtReady(() => {
    const promo = getActivePromotion()
    if (promo) {
      setRoutePromotion(route, promo)
      clearActivePromotion()
    }
  })

  router?.beforeResolve((to: any, _from: any, next: any) => {
    const promo = getActivePromotion()
    if (!promo) {
      next()
      return
    }

    setRoutePromotion(to, promo)
    clearActivePromotion()
    next()
  })
})
